export const ORIGIN = 'origin';
export const DESTINATION = 'destination';

export const THAILAND = 'Thailand';
export const CHINA = 'China';
export const INDIA = 'India';
export const MYANMAR = 'Myanmar';
export const VIETNAM = 'Vietnam';

export enum DestinationTypes {
  CITY = 'CITY',
  AIRPORT = 'AIRPORT',
  FNF = 'FNF',
  FNR = 'FNR',
}
